import { isFeatureEnabled } from '@utils/featureFlags';

declare const ALLOW_VERBOSE_DEBUG: boolean;

/**
 * Build-time switch injected by webpack DefinePlugin: `false` for production
 * bundles unless RESPONA_ALLOW_VERBOSE_DEBUG=true, so the localStorage toggle
 * below is dead code (and tree-shaken) in what ships to customers.
 */
const isVerboseDebugAllowedByBuild = (): boolean =>
  typeof ALLOW_VERBOSE_DEBUG === 'boolean' ? ALLOW_VERBOSE_DEBUG : false;

/**
 * Whether verbose diagnostics (request / response bodies, stream frames, debug
 * logs) may be printed to the console. Replaces the ad-hoc `IS_DEV || GOD_MODE`
 * checks so the toggle can't be flipped by "paste this in your console" on prod.
 *
 * The `GOD_MODE` flag itself lives in the FEATURE_FLAGS registry
 * (localStorage.setItem('GOD_MODE', 'true')); dev builds see it automatically.
 */
export const isVerboseDebugEnabled = (): boolean =>
  isVerboseDebugAllowedByBuild() && isFeatureEnabled('GOD_MODE');
